import { StateCreator } from 'zustand';

import {
  APPOINTMENT_ID,
  APPOINTMENT_USER_ID,
  APPOINTMENT_USER_TYPE,
} from '@constants/storageKeys';
import {
  Appointment,
  AppointmentParticipantType,
} from '@generated/gql/graphql';
import { removeAppointmentFromLocalStorage } from '@utils/storagePropertyManagement';
import { type Store } from '~/src/store/types';

interface AppointmentSession {
  appointmentId: string | null;
  userId: string | null;
  userType: AppointmentParticipantType | null;
}

interface AppointmentStore extends AppointmentSession {
  appointment: Appointment | null;
  setAppointment: (appointment: Nullable<Appointment>) => void;
  setAppointmentSession: (session: Partial<AppointmentSession>) => void;
  resetAppointmentSession: () => void;
}

const readAppointmentSession = (): AppointmentSession => ({
  appointmentId: localStorage.getItem(APPOINTMENT_ID),
  userId: localStorage.getItem(APPOINTMENT_USER_ID),
  userType: localStorage.getItem(
    APPOINTMENT_USER_TYPE
  ) as AppointmentParticipantType | null,
});

const createAppointmentStoreSlice: StateCreator<
  Store,
  [],
  [],
  AppointmentStore
> = (set) => ({
  appointment: null,
  setAppointment: (appointment) => set(() => ({ appointment })),
  ...readAppointmentSession(),
  setAppointmentSession: (session) => set(() => session),
  resetAppointmentSession: () => {
    removeAppointmentFromLocalStorage();
    set(() => readAppointmentSession());
  },
});

export { createAppointmentStoreSlice };
export { type AppointmentStore, type AppointmentSession };
